import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import {
  subscribeInstallPrompt,
  triggerInstallPrompt,
  dismissInstallPrompt,
} from "@/pwa/registerSW";
import { toast } from "sonner";

export function InstallAppMenuItem() {
  const [available, setAvailable] = useState(false);

  useEffect(() => subscribeInstallPrompt(setAvailable), []);

  if (!available) return null;

  const handleInstall = async (e: Event) => {
    e.preventDefault();
    const outcome = await triggerInstallPrompt();
    if (outcome === "accepted") {
      toast.success("Installing the app...");
    } else if (outcome === "dismissed") {
      dismissInstallPrompt();
    }
  };

  return (
    <DropdownMenuItem onSelect={handleInstall} className="cursor-pointer">
      <Download className="mr-2 h-4 w-4" />
      Install the app
    </DropdownMenuItem>
  );
}
